import { FilteredCreditApplication, formatDate } from '@applyonline/shared'
import { addDays, addMonths, isLastDayOfMonth, isWeekend, parse } from '@if/core/date'
import { EProvince, EWorksheetStatus } from '@if/core/types'

const isNotEndOfMonthAndWeekday = (date: Date) => isWeekend(date) && !isLastDayOfMonth(date)

const isHoliday = (date: Date, listHolidays: Date[]) => {
  const formattedDate = formatDate(date)
  return listHolidays?.toString().includes(formattedDate)
}

export const cantSelectDateForActivation = (date: Date, listHolidays: Date[]) => {
  return isHoliday(date, listHolidays) || isNotEndOfMonthAndWeekday(date)
}

export const getClosestDeliveryOn = (
  date: Date,
  listHolidays: Date[],
  allowActivationDateWeekendOrHoliday: boolean,
): Date => {
  if (allowActivationDateWeekendOrHoliday) {
    return date
  }

  if (cantSelectDateForActivation(date, listHolidays)) {
    const nextDay = addDays(date, 1)
    return getClosestDeliveryOn(nextDay, listHolidays, allowActivationDateWeekendOrHoliday)
  }

  return date
}

const maxFirstPaymentDelayInDays = 45
const alisAvailableFirstPaymentDayOptions = [1, 15]
export const computeFirstPaymentDateOptions = (activationDate: string) => {
  const availableDates: Date[] = []
  const activationDateAsDate = activationDate ? parse(activationDate, 'yyyy-MM-dd', new Date()) : new Date()
  const earliestPaymentDate = addDays(activationDateAsDate, 5)
  const maxPaymentDate = addDays(activationDateAsDate, maxFirstPaymentDelayInDays)

  const numberOfMonthsToCover = maxFirstPaymentDelayInDays / 28 + 2 // does not have to be precise
  for (let i = 0; i < numberOfMonthsToCover; i++) {
    const date = addMonths(earliestPaymentDate, i)
    alisAvailableFirstPaymentDayOptions.forEach((day) => {
      const paymentDate = new Date(date.getFullYear(), date.getMonth(), day)
      if (paymentDate >= earliestPaymentDate && paymentDate <= maxPaymentDate) {
        availableDates.push(paymentDate)
      }
    })
  }

  return availableDates
}

export const canAccessWorksheet = (creditApp: FilteredCreditApplication) => {
  return (
    creditApp.allIncomesConfirmed &&
    creditApp.worksheet?.status === EWorksheetStatus.Draft &&
    creditApp.allTaskCompletedForCVT
  )
}
export const provinceSupportsInsurance = (isInsuranceAvailableForAllProvinces: boolean, stateIso: EProvince) => {
  return (
    isInsuranceAvailableForAllProvinces ||
    (stateIso && stateIso !== EProvince.Quebec && stateIso !== EProvince.Saskatchewan)
  )
}
